import { styled } from 'styled-components';
import { Row } from 'antd';
import { BLACK } from '../../styles/colors';
import { remToPx } from 'utils/utils';

const LeagueLogoImg = styled.img`
  height: ${remToPx(5.25)}px;
`;

const Wrapper = styled(Row)`
  height: 6.25rem;
  background-color: ${BLACK};
  padding: 0.5rem;
`;

export { LeagueLogoImg, Wrapper };
